import styled, { keyframes } from 'styled-components'
import { ButtonBase } from 'utils/base'

const formBreakpoint = '767.9px'

export const FormContainer = styled.div`
  position: fixed;
  left: 50%;
  top: 1.6rem;
  transform: translateX(-50%);
  z-index: var(--form-z-index);

  @media (max-width: ${formBreakpoint}) {
    left: 1.6rem;
    right: 1.6rem;
    transform: translateX(0);
  }
`

export const StyledForm = styled.form`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 0.8rem;

  @media (max-width: ${formBreakpoint}) {
    flex-direction: column;
    align-items: stretch;
    gap: 0.4rem;
  }
`

export const SubmitButton = styled(ButtonBase)`
  color: var(--light);
  font-size: 1.6rem;
  line-height: 2.4rem;
  background-color: var(--brand-700);
  border-radius: 0.6rem;
  height: 4rem;
  min-width: 7.8rem;

  @media (max-width: ${formBreakpoint}) {
    width: 100%;
  }
`

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`

export const Loader = styled.span`
  position: relative;
  display: inline-block;
  width: 1.765rem;
  height: 1.765rem;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: var(--light);
  animation: ${rotate} 2s linear infinite;
`
